/**
 * @desc Snowmaking layers to import into the store
 *
 * @author Mike Hamilton <mike@mikehamilton.ca>
 */

import blackcombgondola from "./blackcombgondola";
import excelerator from "./excelerator";
import excalibur from "./excalibur";
import showcase from "./showcase";
import glacierexpress from "./glacierexpress";
import jerseycream from "./jerseycream";
import crystal from "./crystal";
import seventhheaven from "./seventhheaven";
import catskinner from "./catskinner";
import magicchair from "./magicchair";
import blackcombcarpet from "./blackcombcarpet";

import whistlercarpet from "./whistlercarpet";
import symphony from "./symphony";
import franz from "./franz";
import harmony from "./harmony";
import peakchair from "./peakchair";
import emerald from "./emerald";
import olympic from "./olympic";
import whistlertbar from "./whistlertbar";
import redchair from "./redchair";
import garbanzo from "./garbanzo";
import creeksidegondola from "./creeksidegondola";
import fitzsimmons from "./fitzsimmons";

export default {
  modules: {
    seventhheaven,
    blackcombcarpet,
    blackcombgondola,
    catskinner,
    creeksidegondola,
    crystal,
    excalibur,
    excelerator,
    fitzsimmons,
    glacierexpress,
    jerseycream,
    magicchair,
    showcase,
    emerald,
    franz,
    garbanzo,
    harmony,
    olympic,
    peakchair,
    redchair,
    symphony,
    whistlercarpet,
    whistlertbar
  }
};
